import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import * as XLSX from 'xlsx';

// var mqtt    = require('mqtt');
// var options = {
//     protocol: 'mqtt',
//     // clientId uniquely identifies client
//     // choose any string you wish
//     clientId: 'b0908853'    
// };
// var client  = mqtt.connect('ws://mqtt.nadunet.es:8083', options);

// var client  = mqtt.connect('ws://nadunet.es:8083');
// client.on('connect', function () {
//   client.subscribe('outTopic', function (err) {
//     if (!err) {
//       client.publish('outTopic', '1');
//     }
//   });
// });
// client.on('message', function (topic, message) {
//   // message is Buffer
//   console.log("--------- MQTT ---------");
//   console.log(message.toString());
//   client.end();
// });

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920
};

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

var messageCounter = 0;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    this.state = {
      servicesSize: "auto",
      customersChartReady: false,
      ordersToDisplayInChart: 6,
      prizeNumber: 0,
      mustSpin: false,
      waitingResult: false,
      fileData: [],
      cellValue: '',
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.refreshInternet = this.refreshInternet.bind(this);
    this.loadCustomersChart = this.loadCustomersChart.bind(this);
    this.createActiveClientsCard = this.createActiveClientsCard.bind(this);
    this.createMobileProceduresCard = this.createMobileProceduresCard.bind(this);
    this.createMobileRejectedProceduresCard = this.createMobileRejectedProceduresCard.bind(this);
    this.createWebMobileRequestsCard = this.createWebMobileRequestsCard.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.publishChange = this.publishChange.bind(this);
    this.downloadXml = this.downloadXml.bind(this);

    let externalUsers = [
      "Oniti"
    ];
    if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
      this.props.history.push("/clientes");
    }
  }
  componentDidMount() {
    // client.subscribe('naduhome_1/outTopic');
    // client.on('message', this.updateStatus.bind(this));
    // client.on('connect', () => {
    //   // console.log("");
    //   // console.log("----------------------------------------");
    //   // console.log("------------ MQTT Connected ------------");
    //   // console.log("----------------------------------------");
    //   // console.log("");
    //   // client.publish('inTopic', '0');
    // });
  }
  updateStatus(topic, message) {
    // console.log("------------ MQTT: " + topic + " [" + messageCounter++ + "] ------------");
    // let msg = message.toString();
    // // console.log(msg);
    // this.setState({ message: msg });
  }
  publishChange() {
    // let message = "0";
    // let topic = "naduhome_1/inTopic";
    // if (this.state.message === "0") message = "1";
    // // console.log("------------ MQTT OUT: " + topic + " [" + messageCounter++ + "] ------------");
    // // console.log(message);
    // client.publish(topic, message);
  }
  loadCustomersChart() {
    let customersChartDates = [];
    let customersChartCounts = [];
    let partialOrders = this.props.mainState.customersLastMonths.sort((a, b) => new Date(...a.month.split('-')
    .reverse()) - new Date(...b.month.split('-').reverse()));

    partialOrders.map((currentCount, key) =>{
      customersChartDates.push(
        moment(currentCount.month, "DD-M-YYYY").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      customersChartCounts.push(currentCount.count);
    });

    let customersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: customersChartDates,
          datasets: [
            {
              label: "Clientes",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: customersChartCounts
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value;// + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    this.setState({
      customersChartReady: true,
      customersChart: customersChart
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    /*if(this.props.mainState.customersMobilesLoaded && this.props.mainState.customersMobilesCount > 0){
      mobileContent = 
        <Statistics
          showIcon
          iconState="primary"
          icon="tech_mobile"
          title={this.props.mainState.customersMobilesCount}
          subtitle="Móviles activos"
        />;
    }else if(this.props.mainState.customersMobilesLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="tech_mobile"
          title={0}
          subtitle="Ninguna línea móvil activa"
        />;
    }else{
      mobileContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Móviles"
        />;
    }*/
    
    mobileContent = 
      <Statistics
        showIcon
        iconState="primary"
        icon="now-ui-icons loader_gear"
        title="Configuración"
        subtitle="Configura las conexiones"
      />;
    
    mobileContent = 
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/configuracion"}>
                  {mobileContent}
                </Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>;

    return mobileContent;
  }
  createMobileProceduresStyle(procedureType) {
    let statistic = null;
    let procedureStateColor = "default";
    let procedureStateIcon = "default";
    let procedureStateText = /*"Trámites " + */procedureType.estado_tramite;
    // let isCurrentStatus = procedureType.estado_tramite === this.state.procedureStatus;

    switch (procedureType.estado_tramite) {
      case "Pendiente": 
        procedureStateColor = "default";
        procedureStateIcon = "travel_info";
        procedureStateText = procedureStateText + "s";
        break;
      case "Procesando": 
        procedureStateColor = "warning";
        procedureStateIcon = "loader_refresh spin";
        break;
      case "Error": 
        procedureStateColor = "danger";
        procedureStateIcon = "health_ambulance";
        // procedureStateText = "Trámites con " + procedureType.estado_tramite;
        break;
      case "Aceptado": 
        procedureStateColor = "info";
        procedureStateIcon = "ui-1_check";
        procedureStateText = procedureStateText + "s";
        break;
      case "Finalizado": 
        procedureStateColor = "primary";
        procedureStateIcon = "ui-2_favourite-28";
        procedureStateText = procedureStateText + "s";
        break;
      case "ICC previo incorrecto": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_settings-90";
        procedureStateText = /*"Trámites "error */"prev icc";
        break;
      case "Rechazado": 
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_time-alarm";
        procedureStateText = procedureStateText + "s";
        // procedureStateText = procedureStateText + " [" + procedure.motivo_rechazo + "]"
        break;
      case "Cancelado": 
        procedureStateColor = "default";
        procedureStateIcon = "media-1_button-power";
        procedureStateText = procedureStateText + "s";
        break;
      default:
    }

    statistic =
      <Statistics
        showIcon
        iconState={procedureStateColor}
        icon={procedureStateIcon}
        title={procedureType.contador}
        subtitle={procedureStateText}
      />;

    return statistic;
  }
  createMobileProceduresCard() {
    let mobileContent = [];
    if(this.props.mainState.mobileProceduresCountLoaded && this.props.mainState.mobileProceduresCount.length > 0){
      this.props.mainState.mobileProceduresCount.map((procedureType, key) => {
        mobileContent.push(
          <Col xs={12} md={this.state.servicesSize} key={procedureType.estado_tramite}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={"/tramites"}>
                      {this.createMobileProceduresStyle(procedureType)}
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.mobileProceduresCountLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ningún trámite en proceso"
        />;
    } else {
      mobileContent.push(
        <Col xs={12} md={this.state.servicesSize} key="cargando-tramites">
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Cargando..."
                    subtitle="Trámites"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  createWebMobileRequestsStyle(requestType) {
    let statistic = null;
    let requestStateColor = "default";
    let requestStateIcon = "default";
    let requestStateText = /*"Solicitudes " + */requestType.estado_solicitud;

    switch (requestType.estado_solicitud) {
      case "Ficha no creada": 
        requestStateColor = "danger";
        requestStateIcon = "ui-2_time-alarm";
        break;
      case "Ficha lista": 
        requestStateColor = "warning";
        requestStateIcon = "ui-2_settings-90";
        break;
      case "SIM enviada": 
        requestStateColor = "info";
        requestStateIcon = "shopping_delivery-fast";
        // procedureStateText = "Trámites con " + requestType.estado_tramite;
        break;
      case "SIM recibida": 
        requestStateColor = "primary";
        requestStateIcon = "ui-1_check";
        break;
      default:
    }

    statistic =
      <Statistics
        showIcon
        iconState={requestStateColor}
        icon={requestStateIcon}
        title={requestType.contador}
        subtitle={requestStateText}
      />;

    return statistic;
  }
  createWebMobileRequestsCard() {
    let mobileContent = [];
    if(this.props.mainState.webMobileRequestsCountLoaded && this.props.mainState.webMobileRequestsCount.length > 0){
      this.props.mainState.webMobileRequestsCount.map((requestType, key) => {
        mobileContent.push(
          <Col xs={12} md={this.state.servicesSize} key={requestType.estado_solicitud}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={"/web/solicitudes-movil"}>
                      {this.createWebMobileRequestsStyle(requestType)}
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.webMobileRequestsCountLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ninguna solicitud"
        />;
    } else {
      mobileContent.push(
        <Col xs={12} md={this.state.servicesSize} key="cargando-solicitudes">
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Cargando..."
                    subtitle="Solicitudes"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  createMobileRejectedProceduresCard() {
    let mobileContent = null;
    if(this.props.mainState.mobileRejectedProceduresCountLoaded && this.props.mainState.mobileRejectedProceduresCount > 0){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="ui-1_simple-remove"
          title={this.props.mainState.mobileRejectedProceduresCount}
          subtitle="Trámites rechazados"
        />;
    }else if(this.props.mainState.mobileRejectedProceduresCountLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="primary"
          icon="ui-1_simple-remove"
          title={0}
          subtitle="Ningún trámite rechazado"
        />;
    }else{
      mobileContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Trámites rechazados"
        />;
    }

    mobileContent = 
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/tramites"}>
                  {mobileContent}
                </Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>;

    return mobileContent;
  }
  createInternetCards() {
    let internetContent = null;
    if(this.props.mainState.hasInternet && this.props.mainState.internetLoaded){      
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="primary"
                    icon="location_world"
                    title="Internet"
                    subtitle={this.props.mainState.internet_plan.name}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else if(this.props.mainState.internetLoaded){
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="location_world"
                    title="Internet"
                    subtitle="Sin conexión en casa..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      internetContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Internet"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return internetContent;
  }
  createActiveClientsCard() {
    let activeClientsContent = null;
    /*if(this.props.mainState.customersCountLoaded && this.props.mainState.customersCount > 0){      
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="info"
          icon="users_single-02"
          title={this.props.mainState.customersCount}
          subtitle="Clientes"
        />;
    }else if(this.props.mainState.customersCountLoaded){
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="users_single-02"
          title={0}
          subtitle="Sin clientes activos"
        />;
    }else{
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Clientes"
        />;
    }*/

    activeClientsContent = 
      <Statistics
        showIcon
        iconState="info"
        icon="users_single-02"
        title="Usuarios"
        subtitle="Usando 4 de 31"
      />;

    activeClientsContent = 
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/clientes"}>
                  {activeClientsContent}
                </Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>;
      
    return activeClientsContent;
  }
  refreshInternet() {
    /* ////console.log("################ REFRESH INTERNET ###############"); */
    this.props.loadInternet();
  }
  downloadXml(url, orderNumber, event){
    // this.setState({
    //   [orderNumber]: true
    // });
    url = "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/test_billing";
    axios({
      url: url,
      method: 'POST',
      responseType: 'blob', // important
      data: {params: {}}
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "remesa_test".concat(".xml")
      );
      document.body.appendChild(link);
      link.click();
      // this.setState({
      //   [orderNumber]: false
      // });
    });
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("Archivo", file);

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Assuming you want to get the value of cell A1
      const cellValue = worksheet['A2'] ? worksheet['A2'].v : '';

      this.setState({
        fileData: workbook,
        cellValue: cellValue,
      });
    };

    reader.readAsArrayBuffer(file);
  };
  render() {
    if (this.props.userData.isTechnician()) {
      return <Redirect to="/citas" />;
    }
    // console.log(" ESTADO ACTUAL ");
    // console.log(this.state);
    // let mqttButton = 
    //   <Button icon onClick={this.publishChange} color={this.state.message === "1"? "primary" : "danger"}>
    //     <i className="now-ui-icons business_bulb-63" />
    //   </Button>;
    if (this.props.mainState.customersLastMonthsLoaded && !this.state.customersChartReady) this.loadCustomersChart();
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div>
          //     <h6 style={dashboardOrdersTitleStyle}>Evolución clientes</h6>
          //   <Line
          //     data={!this.state.customersChartReady? dashboardPanelChart.data : this.state.customersChart.data}
          //     options={!this.state.customersChartReady? dashboardPanelChart.options : this.state.customersChart.options}
          //   />
          //   </div>
          // }
        />
        <div className="content">
          <Row>
            {/* <Button
              color="danger"
              size="sm"
              onClick={e =>
                this.downloadXml(null, null, e)
              }
            >
              Test remesa XML
            </Button> */}
            {/* {mqttButton} */}
          </Row>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div>
                    <input type="file" accept=".xlsx" onChange={this.handleFileChange} />
                    <div>
                      <p>Cell A2 Value:</p>
                      <p>{this.state.cellValue}</p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {/*this.createInternetCards()*/}
            {this.createActiveClientsCard()}
            {this.createMobileCards()}
            {/* {this.createMobileRejectedProceduresCard()} */}
          </Row>
          {/* <Row>
            <Card className="card-plain">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons education_paper" /> Trámites{"  "}
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  {this.createMobileProceduresCard()}
                </Row>
              </CardBody>
            </Card>
          </Row>
          <Row>
            <Card className="card-plain">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons education_paper" /> Solicitudes{"  "}
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  {this.createWebMobileRequestsCard()}
                </Row>
              </CardBody>
            </Card>
          </Row> */}
          {/* <Row>
            <Card> 
              <CardBody>
                <Button
                  color="info"
                  size="primary"
                  onClick={e =>
                    this.addSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-add" />
                  </div>
                </Button>{"  "}
                <Button
                  color="danger"
                  size="sm"
                  onClick={e =>
                    this.subSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-delete" />
                  </div>
                </Button>{"  "}
                <Button
                  color="info"
                  size="sm"
                  onClick={e =>
                    this.refreshInternet()
                  }
                >
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69" />
                  </div>
                </Button>
              </CardBody>
            </Card> 
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="primary"
                        icon="ui-2_chat-round"
                        title="859"
                        subtitle="Messages"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="success"
                        icon="business_money-coins"
                        title={
                          <span>
                            <small>$</small>3,521
                          </span>
                        }
                        subtitle="Today Revenue"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="info"
                        icon="users_single-02"
                        title="562"
                        subtitle="Customers"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="danger"
                        icon="objects_support-17"
                        title="353"
                        subtitle="Support Requests"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Users</CardCategory>
                  <CardTitle tag="h2">34,252</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveUsersChart.data}
                      options={dashboardActiveUsersChart.options}
                    />
                  </div>
                  <Table responsive>
                    <tbody>{this.createTableData()}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Summer Email Campaign</CardCategory>
                  <CardTitle tag="h2">55,300</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardSummerChart.data}
                      options={dashboardSummerChart.options}
                    />
                  </div>
                  <div className="card-progress">
                    <Progress badge="Delivery Rate" value="90" />
                    <Progress color="success" badge="Open Rate" value="60" />
                    <Progress color="info" badge="Click Rate" value="12" />
                    <Progress color="primary" badge="Hard Bounce" value="5" />
                    <Progress color="danger" badge="Spam Report" value="0.11" />
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Countries</CardCategory>
                  <CardTitle tag="h2">105</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveCountriesCard.data}
                      options={dashboardActiveCountriesCard.options}
                    />
                  </div>
                  <VectorMap
                    map={"world_mill"}
                    backgroundColor="transparent"
                    zoomOnScroll={false}
                    containerStyle={{
                      width: "100%",
                      height: "280px"
                    }}
                    containerClassName="map"
                    regionStyle={{
                      initial: {
                        fill: "#e4e4e4",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0
                      }
                    }}
                    series={{
                      regions: [
                        {
                          values: mapData,
                          scale: ["#AAAAAA", "#444444"],
                          normalizeFunction: "polynomial"
                        }
                      ]
                    }}
                  />
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[{ i: "now-ui-icons ui-2_time-alarm", t: "Last 7 days" }]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Best Selling Products</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive className="table-shopping">
                    <thead>
                      <tr>
                        <th className="text-center" />
                        <th>PRODUCT</th>
                        <th>COLOR</th>
                        <th>Size</th>
                        <th className="text-right">PRICE</th>
                        <th className="text-right">QTY</th>
                        <th className="text-right">AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={jacket} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#jacket">Suede Biker Jacket</a>
                          <br />
                          <small>by Saint Laurent</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>3,390
                        </td>
                        <td className="td-number">1</td>
                        <td className="td-number">
                          <small>€</small>549
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={shirt} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#shirt">Jersey T-Shirt</a>
                          <br />
                          <small>by Balmain</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>499
                        </td>
                        <td className="td-number">2</td>
                        <td className="td-number">
                          <small>€</small>998
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={swim} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#pants">Slim-Fit Swim Short </a>
                          <br />
                          <small>by Prada</small>
                        </td>
                        <td>Red</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>200
                        </td>
                        <td className="td-number">3</td>
                        <td className="td-number">
                          <small>€</small>799
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5" />
                        <td className="td-total">Total</td>
                        <td className="td-price">
                          <small>€</small>2,346
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx